import React, { Component } from 'react'
import { Box, RoundedLabel, Icons } from 'components'
import { CustomTmrItem } from 'api/types'
import Products from 'api/Products'
import { T, __ } from 'translations/i18n'
import { Spacer } from './Various'
import { CustomItemInfoModal } from './modals'
import CustomItemRowProvider from './CustomItemRowProvider'
import {
  Row,
  Separator,
  ProductImage,
  ProductCode,
  ItemEpc,
  Message,
} from './CustomItemRowProvider'
import styled from '@emotion/styled'

interface Props {
  id: any
  item: CustomTmrItem
  onInfoPress?: (item: CustomTmrItem) => void
  onDeleteCallback?: (item: CustomTmrItem) => void
}

interface State {
  visibleItemModal: boolean
}

export default class CustomItemRow extends Component<Props, State> {
  state: State = {
    visibleItemModal: false,
  }

  openItemInfoModal = () => this.setState({ visibleItemModal: true })
  closeItemInfoModal = () => this.setState({ visibleItemModal: false })

  onRowPress = () => {
    const { onInfoPress, item } = this.props
    if (onInfoPress) return () => onInfoPress(item)
    if (!item.id) return undefined
    if (!onInfoPress) return this.openItemInfoModal
    return undefined
  }

  onDeletePress = () => {
    const { onDeleteCallback, item } = this.props
    if (onDeleteCallback) return () => onDeleteCallback(item)
    return undefined
  }
  getItemStatus = (status: string) => {
    let component
    switch (status) {
      case 'CQ':
        component = <TagStatus style={{ backgroundColor: '#1BBA60', color: 'white' }}>{__(T.caps_lock.encoded)}</TagStatus>
        break
      case 'CQ2':
        component = <TagStatus style={{ backgroundColor: '#1BBA60', color: 'white' }}>{__(T.caps_lock.tested)}</TagStatus>
        break
      case 'SC':
        component = <TagStatus style={{ backgroundColor: '#FF9432', color: 'white' }}>{__(T.caps_lock.discarded)}</TagStatus>
        break
      case 'IN':
        component = <TagStatus style={{ backgroundColor: '#EF4141', color: 'white' }}>{__(T.caps_lock.canceled)}</TagStatus>
        break
      case 'SCNR':
        component = <TagStatus style={{ backgroundColor: '#480808', color: 'white' }}>{__(T.caps_lock.discarded_nr)}</TagStatus>
        break
      case 'PC':
        component = <TagStatus style={{ backgroundColor: '#454545', color: 'white' }}>{status}</TagStatus>
        break
      case 'MP':
        component = <TagStatus style={{ backgroundColor: '#f9dd3f', color: 'white' }}>{status}</TagStatus>
        break
      case 'LA':
        component = <TagStatus style={{ backgroundColor: '#18a0c2', color: 'white' }}>{status}</TagStatus>
        break
      default:
        component = <TagStatus style={{ backgroundColor: '#42474a', color: 'white' }}>{__(T.caps_lock.unknown)}</TagStatus>
        break
    }
    return component
  }
  render() {
    const { item, id, onDeleteCallback } = this.props
    const { visibleItemModal } = this.state
    if (!item) return <></>
    const { product } = item

    let tagType
    if (!item.product) tagType = __(T.misc.unknown_product)
    if (!item.product && item.upc) tagType = __(T.misc.unknown_tag)
    if (!item.upc && !item.product) tagType = __(T.misc.invalid_tag)

    const upc = item.upc ?? item.product?.code

    let status: 'error' | 'warning' | undefined
    status = item.__processedStates?.find((state) => state === 'ERROR') ? 'error' : undefined

    const message = CustomItemRowProvider.getItemMessage(item)
    return (
      <Row row id={id} onClick={onDeleteCallback ? undefined : this.onRowPress()}>
        <Box center p={10}>
          <ProductImage src={Products.getImageUrl(product?.code)} alt="item" />
        </Box>

        <Separator />

        <Box flex p={20} pr={0}>
          <Box style={{ maxWidth: 'fit-content', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
            <ProductCode>{upc ?? __(T.misc.unknown).toUpperCase()}</ProductCode>
            <ItemEpc>{item.product?.description ?? item.epc}</ItemEpc>
            <RoundedLabel maxWidth={230} label={'Serie'} value={item.productionOrderRow?.order?.code} />
          </Box>
          <Spacer />
          <Box row style={{ justifyContent: 'flex-start' }}>
            <RoundedLabel maxWidth={230} label={__(T.misc.style)} value={product?.style?.valueDescription} />
            <RoundedLabel maxWidth={130} label={__(T.misc.size)} value={product?.size?.value} />
            <RoundedLabel maxWidth={150} label={__(T.misc.color)} value={product?.color?.value} />
            <RoundedLabel value={tagType?.toUpperCase()} />
          </Box>
          {!!message && (
            <Box row style={{ justifyContent: 'flex-start' }}>
              <Message status={status}>{message}</Message>
            </Box>
          )}
        </Box>
        {onDeleteCallback && (
          <Box p={30} center onClick={this.onDeletePress()}>
            <Icons.Delete />
          </Box>
        )}
        <TagStatus flex>{this.getItemStatus(item.status ?? '')}</TagStatus>
        {this.onRowPress() && !onDeleteCallback && (
          <Box p={30} center>
            <Icons.Info />
          </Box>
        )}
        {visibleItemModal && (
          <CustomItemInfoModal visible={visibleItemModal} item={item} onClose={this.closeItemInfoModal} />
        )}
      </Row>
    )
  }
}

const TagStatus = styled((props) => <Box {...props} />)`
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  padding-left: 25px;
  padding-right: 25px;
  border-radius: 10px;
  margin: auto;
`